export default __webpack_public_path__ + "static/media/security.ddd4609f.svg";